import type { TFunction } from 'i18next';
import type { StaffBookingResponse } from '../../api/generated';
import type { TableColumn } from '../UI';
import {
  actionsColumn,
  entityNameCell,
  reasonColumn,
  resolveEntityNames,
  standardDateColumn,
  standardRepeatsColumn,
  standardTimeColumn
} from '../Bookings/shared';

interface StaffBookingColumnHandlers {
  staffNameById: Map<string, string>;
  onEdit: (booking: StaffBookingResponse) => void;
  onDelete: (booking: StaffBookingResponse) => void;
}

export const getStaffBookingColumns = (
  t: TFunction,
  { staffNameById, onEdit, onDelete }: StaffBookingColumnHandlers
): TableColumn<StaffBookingResponse>[] => [
  {
    key: 'staff',
    header: t('staff-booking-col-staff'),
    render: (booking) =>
      entityNameCell({
        names: resolveEntityNames(booking.staffIds, staffNameById),
        allLabel: booking.appliesToAllStaff ? t('staff-booking-all-staff') : null
      })
  },
  standardDateColumn(t, 'staff-booking-col-date'),
  standardRepeatsColumn(t, 'staff-booking-col-repeats'),
  standardTimeColumn(t, 'staff-booking-col-time'),
  reasonColumn(t, 'staff-booking-col-reason'),
  actionsColumn(t, {
    editKey: 'staff-booking-edit',
    deleteKey: 'staff-booking-delete-title',
    onEdit,
    onDelete
  })
];
